$(document).ready(() => {

  function initOpenSidebar() {
    var sidebarLabelSlt = ".sidebar-label",
      sidebarLabelElm = $(sidebarLabelSlt);
  
    if (sidebarLabelElm.length) {
      $("body")
        .off("click.openSidebar")
        .on("click.openSidebar", sidebarLabelSlt, function () {
          $("html").addClass("sidebar-open");
        });
    }

    $(document).click(function (e) {
      if (!$(e.target).closest("#main-collection-filters, .sidebar-label ").length) {
  
        if (sidebarLabelElm.length) {       
            $("html").removeClass("sidebar-open");
        }
      }
    });

    
  }
  initOpenSidebar();
  
  function closeSidebar() {
    if ($(".sidebar .close-sidebar").length) {
        $("body")
          .off("click.closeCustomer", ".sidebar .close-sidebar")
          .on("click.closeCustomer", ".sidebar .close-sidebar", function (e) {
            e.preventDefault();
            e.stopPropagation();
  
            $("html").removeClass("sidebar-open");
          });
      }
  }

  closeSidebar();

  
  function viewModeLayout() {
      var viewMode = $("[data-view-as]"),
        viewModeActive = viewMode.find(".icon-mode.active"),
        col = viewModeActive.data("col"),
        products = $(".collection-template .product-collection"),
        gridItem = products.find(".grid-item"),
        strClass = "col-12 col-6 col-md-4 col-lg-3 col5",
        gridClass = "grid-2 grid-3 grid-4 grid-5 products-grid products-list";

      switch (col) {
        case 1:
          if (gridItem.hasClass("grid-item-mansory")) {
            products.removeClass(gridClass).addClass("products-list");
          } else {
            products.removeClass("products-grid").addClass("products-list");
          }

          gridItem.removeClass(strClass).addClass("col-12");
          break;

        default:
          switch (col) {
            case 2:
              if (gridItem.hasClass("grid-item-mansory")) {
                products.removeClass(gridClass).addClass("products-grid");
              } else {
                products.removeClass("products-list").addClass("products-grid");
              }
              gridItem.removeClass(strClass).addClass("col-6");
              break;

            case 3:
              if (gridItem.hasClass("grid-item-mansory")) {
                products.removeClass(gridClass).addClass("products-grid");
              } else {
                products.removeClass("products-list").addClass("products-grid");
              }
              gridItem.removeClass(strClass).addClass("col-6 col-md-4");
              break;

            case 4:
              if (gridItem.hasClass("grid-item-mansory")) {
                products.removeClass(gridClass).addClass("products-grid");
              } else {
                products.removeClass("products-list").addClass("products-grid");
              }
              gridItem
                .removeClass(strClass)
                .addClass("col-6 col-md-4 col-lg-3");
              break;

            case 5:
              if (gridItem.hasClass("grid-item-mansory")) {
                products.removeClass(gridClass).addClass("products-grid");
              } else {
                products.removeClass("products-list").addClass("products-grid");
              }
              gridItem
                .removeClass(strClass)
                .addClass("col-6 col-md-4 col-lg-3 col5");
              break;
          }
      }

      //ella.initMasonry();
    }
  
  
  function addEventViewModeLayout() {

      $("body").on("click", ".view-mode .icon-mode", function (e) {
        e.preventDefault();

        var self = $(this),
          col = self.data("col"),
          parents = self.closest("[data-view-as]");

        if (!self.hasClass("active")) {
          parents.find(".icon-mode").removeClass("active");
          self.addClass("active");

          viewModeLayout();
          //ella.initMasonry();

          if (window.innerWidth > 767) {
            $(".product-collection")
              .find("img")
              .removeClass("lazyautosizes ls-is-cached lazyloaded")
              .addClass("lazyload");
          }
        }
      });

      $(".view-mode .icon-mode.clicky").trigger("click");
    }

    addEventViewModeLayout();

    // dropdowns
    $(".toolbar [data-toggle=dropdown]:not(.initialized)").click(() => {
      $(this).parent().children(".dropdown-menu").toggleClass("show");
      $(this).addClass("initialized");
    });
});

    